import { SVGProps } from 'react';

const BusFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6 2 7m8-1h4m8 1-2-1m-2 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2m12 0H6m12 0v2M6 19v2M4 11h16M8 15h.01M16 15h.01"
    />
  </svg>
);
export default BusFront;
